import { render, staticRenderFns } from "./ObterAtendimentoTerceiro.vue?vue&type=template&id=487d102e&"
import script from "./ObterAtendimentoTerceiro.vue?vue&type=script&lang=js&"
export * from "./ObterAtendimentoTerceiro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports